// extracted by mini-css-extract-plugin
module.exports = {"main-wrapper":"Footer_main-wrapper__8veMi","leftbar":"Footer_leftbar__tk8o9","copyright":"Footer_copyright__1SBdq"};